'use client';

import { ThemeProvider } from '@mui/material/styles';
import React from 'react';

import { muiTheme } from '../theme';

/**
 * MUI ThemeProvider - Pretendard 폰트 전역 적용
 * layout.tsx에서 AppRouterCacheProvider 내부에 사용
 */
const MuiThemeProvider = ({ children }: { children: React.ReactNode }) => {
  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
};

export default MuiThemeProvider;
